export default __webpack_public_path__ + "static/media/HowHeart.aeb2c8d4.svg";